// eslint-disable-next-line no-restricted-imports
import {
  ClientsQueryVariables,
  QueryInput_ClientController_GetList_RiskLevels_Items as RiskLevelsApi,
  QueryInput_ClientController_GetList_OnboardingStatuses_Items as ClientOnboardingStatusTypeApi,
} from 'api/generated/graphql';
import { ClientsFilters } from 'api/types/data';
import { RiskLevelFilterType } from 'api/types/entity';
import { lodash } from 'helpers';

type Result = Pick<
  ClientsQueryVariables,
  | 'search'
  | 'riskLevels'
  | 'onboardingStatuses'
  | 'registrationCountries'
  | 'residentialCountries'
>;

const riskLevels: Record<RiskLevelFilterType, RiskLevelsApi> = {
  [RiskLevelFilterType.Unspecified]: RiskLevelsApi.NotSpecified,
  [RiskLevelFilterType.Low]: RiskLevelsApi.Low,
  [RiskLevelFilterType.Medium]: RiskLevelsApi.Medium,
  [RiskLevelFilterType.High]: RiskLevelsApi.High,
};

export const parseClientFiltersParam = (filter?: ClientsFilters): Result => ({
  search: filter?.search || undefined,
  registrationCountries: filter?.registrationCountries,
  residentialCountries: filter?.locationCountries,
  riskLevels: filter?.riskLevels?.length
    ? filter.riskLevels.map((r) => riskLevels[r])
    : undefined,
  onboardingStatuses: filter?.onboardingStatuses?.length
    ? lodash.compact(
        filter?.onboardingStatuses?.map(
          (status) => ClientOnboardingStatusTypeApi[status]
        )
      )
    : undefined,
});
